var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_script"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2729 14.3562L18.0135 10.6156C18.2088 10.4204 18.2088 10.1038 18.0135 9.90853L14.2729 6.16797",
    stroke: "#F9F9F9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.91223 6.16797L2.17167 9.90853C1.97641 10.1038 1.97641 10.4204 2.17167 10.6156L5.91223 14.3562",
    stroke: "#F9F9F9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M11.5428 6L8.47217 14.5294",
    stroke: "#F9F9F9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScript);
export default __webpack_public_path__ + "static/media/ic_script.ec354d34c8b35f2eee18b0e960a5096a.svg";
export { ForwardRef as ReactComponent };